<script>
    import appConfig from "../../../app.config";
    import "swiper/swiper-bundle.css";
    import axios from 'axios';
    import animationData from "@/components/widgets/lupuorrc.json";
    //import TermsConditionsModal from "@/components/modals/terms-conditions-modal.vue";
    import EmandateModal from "@/components/modals/emandate_terms.vue";
    // import Lottie from "@/components/widgets/lottie.vue";
    import Swal from 'sweetalert2';



    // this.$route.params.hash
    export default {
        page: {
            title: "Starter",
            meta: [{
                name: "description",
                content: appConfig.description
            }],
        },
        data() {
            return {
                title: "Starter",
                items: [{
                        text: "Pages",
                        href: "/",
                    },
                    {
                        text: "Starter",
                        active: true,
                    },
                ],
                listCOuntry:[],
                listBank:[],
                listState:[],
                listRelation:[],
                refListing:[],
                LoanListing:[
                    // {
                    //     "id": 1,
                    //     "name": "Personal Loan",
                    //     "created_at": "2022-11-13T14:08:27.000000Z",
                    //     "updated_at": null
                    // }
                ],
                productDetailsList:[],

                disableUpload:true,
                loadingListRef:true,
                loadingUploadFrontNRIC:false,
                loadingUploadBackNRIC:false,
                acceptceking:false,

                detailSeen:false,
                loadNricStatus:false,
                loadRequestCode:false,
                loadLoan:false,

                NetSalray:false,
                UploadSlip:false,
                salryRange:true,
                DisableCheckbox:false,
                DisableCheckboxNone:false,
                sameabove:false,
                CreditSubmitCheck:true,
                disableTOFinance:true,

                Nric_msj:'',
                success_upload_fNric:'',
                success_upload_bNric:'',
                success_upload_msg:'',
                success_upload_bNric_msg:'',
                // checkedNames:'',

                canEmailProceed:0,
                canNricProceed:0,
                frontapprove:0,
                backapprove:0,
                count:0,
                count2nd:0,

                msjVerifycode:'',
                renric:'',
                msjRespon:'',
                ref_name:'',
                tnc:'',
                relationship: '',
                ref_number:'',
                verification:'',
                selected:'',
                companyname:'',
                error_companyname:'',
                error_loan:'',
                general_line:'',
                error_general_line:'',
                bank: '',
                salary_range:'',
                net_salary:'',
                error_salary_range:'',
                aplicationsource:'Online Application',

                abletoSendRequestVerify:true,
                pausedFor5Seconds: false,
                pausedFor6Seconds: false,
                timerCount: '',
                timerEnabled :false,
                loadingCreditCheck:false,

                defaultOptions: { animationData: animationData },

                canProceed:0,
                canProceedNric:0,

                temporayaddress:'',
                postalCodetemp:'',
                citytemp:'',
                statetemp:'',
                countrytemp:'',

                error_ref_name:'',
                error_ref_number:'',
                error_ref_relationship:'',
                error_net_salary:'',
                error_uploadPayslip_:'',
                email_name:'',
                    

                loan_none:false,
                PersonalLoan:false,
                CreditCard:false,
                CarLoan:false,
                Housing:false,
                disableemailVeryfy:false,
                disableTncs:true,
                temporaryAddressDisable:false,
                bankpg: false,
                authpg: false,
                succespg:false,
                emplypg:false,

                error_refSeen:false,

                sku:'',
                product_name:'',
                color_name:'',
                capacity_name:'',
                tenure:'',
                price:'',
                program_fee:'',
                //total_upfront:'',
                refpg:false,
                error_race_cus:false,

                retryCheckCredit:3,

                uploadRetry:1,
                race_cus:'',
                enterWasPressed:false,
            };
        },

       
        methods: {
            checkblacklist(){
                const posting_ = { 
                        namenric:this.firstName,
                        };
                axios.post(process.env.VUE_APP_API_BASEURL+'customer/customerblacklist/'+this.$route.params.id, posting_)
                        .then(response => {
                            if(response.data.status == 'Fail'){
                                this.disableUpload = true;
                                alert("We're sorry ! You have reached the maximum limit of attempt on your application to this program. For any enquiries, kindly contact the ReNew+ team at renew.plus@compasia.com");
                                window.location.href=response.data.url;
                                return false;
                            }   
                        })
                            .catch(error => {
                                this.messageBag = [error.error];
                        });

            },
            // emaillengthlimit(){
            //     if(this.emailAddress.length<27){
            //         this.canNricProceed = 1;
            //                     this.canProceed = this.canEmailProceed * this.canNricProceed;

            //                     this.canProceed = this.canProceed + 1;
            //                     if(this.canProceed >= '2'){
            //                         this.disableUpload = false;
            //                     }
            //     }
            // },
            saveStep1(){
                // if(this.emailAddress.length>27){
                //     alert("Exceeded the maximum count (27 characters)");
                //     this.disableUpload = true;
                // }else{
                //     this.canNricProceed = 1;
                //                 this.canProceed = this.canEmailProceed * this.canNricProceed;

                //                 this.canProceed = this.canProceed + 1;
                //                 if(this.canProceed >= '2'){
                //                     this.disableUpload = false;
                //                 }
                // }
                
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                if(this.nric != this.renric)
                    { 
                        alert('NRIC not matched'); 
                    }else{
                        
                    if (this.firstName == ''){
                        alert('Please Enter Your Name As Per NRIC'); 
                    }else if (this.aplicationsource == '' || this.aplicationsource == null){
                        alert('Please Select Application Source'); 
                    }else if (this.race_cus ==''|| this.race_cus == null || this.race_cus == "null"){
                        this.error_race_cus = true;
                        alert('Please Select Race'); 
                    }else{
                        this.error_race_cus = false;
                        
                        const posting_ = { 
                            temporayaddress: this.temporayaddress,
                            postalCodetemp:this.postalCodetemp, 
                            citytemp:this.citytemp, 
                            statetemp:this.statetemp, 
                            countrytemp:this.countrytemp, 
                            namenric:this.firstName,
                            applicationsource:this.aplicationsource,
                            race_cus:this.race_cus,
                            emailAddress: this.emailAddress
                        };
                        axios.post(process.env.VUE_APP_API_BASEURL+'customer/step1/'+this.$route.params.id, posting_)
                        .then(response => {
                            if (response) {
                                console.log(response.data);
                                if(response.data.status == 'successfully'){
                                    const elem = document.getElementById('pills-info-desc-tab');
                                    elem.click(); 
                                    this.getCustomer();
                                    this.temporaryAddressDisable=true;
                                }else{
                                    alert('fail to save data');
                                }
                            } else {
                                this.messageBag = ['No record.'];
                                this.abletoSendRequestVerify = true;
                            }
                            this.loadRequestCode=false;
                        })
                            .catch(error => {
                                this.messageBag = [error.error];
                        });
                    }
            }
        
            },

            async getBank(){
                await axios.get(process.env.VUE_APP_API_NODEJS+'/bankList')
                .then(response => {
                    console.log("BANK", response.data)
                    if (response) {
                        this.listBank=response.data;
                                                
                    } else {
                        this.messageBag = ['No record.'];
                        this.OrderSeen = false;
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                        this.OrderSeen = false;
                });
            },

            getCustomer(){
                axios.get(process.env.VUE_APP_API_BASEURL+'customer/getdetail/'+this.$route.params.id)
                .then(response => {
                    this.temporayaddress='';
                    this.postalCodetemp='';
                    this.citytemp='';
                    this.statetemp='';
                    this.countrytemp='';
                    this.OrderId = '';
                    // this.race_cus = '';
                    // this.aplicationsource = '';
               

                    if (typeof response.data.customer.id !== 'undefined') {

                        if(response.data.customer.draf == '1'){
                            window.location.href=process.env.VUE_APP_URL+'customer/bank/'+this.$route.params.id+'/'+this.$route.params.hash;
                        }
                        this.temporayaddress=response.data.customer.temporary_address;
                        this.postalCodetemp=response.data.customer.temporary_postalcode;
                        this.citytemp=response.data.customer.temporary_city;
                        this.statetemp=response.data.customer.temporary_state;
                        this.countrytemp=response.data.customer.temporary_country_id;
                        this.temporaryAddressDisable=true;
                        this.customerId = response.data.customer.id;
                        // this.race_cus = response.data.customer.race_cus;
                        // this.aplicationsource = response.data.customer.applicationsource;
                        
                        // console.log(response.data.order);
                        // console.log('****-----****');
                        this.companyname =response.data.customer.employment_company_name;
                        this.general_line = response.data.customer.employment_office_gneral_line;

                        if (typeof response.data.order.id !== 'undefined') {
                            this.OrderId = response.data.order.id;

                            if(response.data.order.front_nric ===null || response.data.order.front_nric ==='' || response.data.order.back_nric ===null || response.data.order.front_nric ===''){
                                
                                // console.log('-------------**********');
                                console.log(response.data.order.front_nric);
                                console.log(response.data.order.back_nric);
                                console.log('Function getCustomer => Front & Back NRIC is NULL');
                            }
                            else{
                                this.disableTOFinance = false;
                                console.log('Front & Back NRIC is exist in table order');
                            }
                        }
                        
                        // this.getCountry();
                        // this.getRelationList();
                        // this.refList();
                        // this.LoanList();
                        // this.getState();
                        // this.getBank();
                        // this.getProductDetails();
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                        this.OrderSeen = false;
                });
            },

            duplicateaddress(){
                // console.log(this.sameabove);
                if(this.sameabove == false){
                    this.temporayaddress = this.addressmix ; 
                    this.postalCodetemp = this.postalCode ;
                    this.citytemp = this.city ; 
                    this.statetemp = this.state; 
                    this.countrytemp = this.country ; 
                }else{
                    this.temporayaddress =''; 
                    this.postalCodetemp = '' ;
                    this.citytemp = '' ; 
                    this.statetemp = ''; 
                    this.countrytemp = '' ; 
                }
                // console.log(this.countrytemp);
            },
            
            getCountry(){
                axios.get(process.env.VUE_APP_API_BASEURL+'country')
                .then(response => {
                    if (response) {
                        this.listCOuntry=response.data;
                        
                    } else {
                        this.messageBag = ['No record.'];
                        this.OrderSeen = false;
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                        this.OrderSeen = false;
                });
            },

            getRelationList(){

                axios.get(process.env.VUE_APP_API_BASEURL+'relation/list')
                .then(response => {
                    if (response) {
                        this.listRelation=response.data;
                        
                    } else {
                        this.messageBag = ['No record.'];
                        this.OrderSeen = false;
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                        this.OrderSeen = false;
                });
            },

            getState(country_id){
                axios.get(process.env.VUE_APP_API_BASEURL+'state/'+country_id)
                .then(response => {
                    if (response) {
                        this.listState=response.data;
                        if (this.state == response.data.id){
                            this.state == response.data.name
                        }
                        // console.log("State",response.data)
                        
                    } else {
                        this.messageBag = ['No record.'];
                        this.OrderSeen = false;
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                        this.OrderSeen = false;
                });
            },

            myDecimal (myNumber) {	
                if(myNumber){	
                    return myNumber.toFixed(2);
                }
                return myNumber;
            },
            getProductDetails(){                
                axios.get(process.env.VUE_APP_API_BASEURL+'program_device/info/'+this.$route.params.id)
                .then(response => {
                    if (response) {
                        this.productDetailsList=response.data;
                        this.product_name = this.productDetailsList[0].product_name
                        this.color_name = this.productDetailsList[0].color_name
                        this.capacity_name = this.productDetailsList[0].capacity_name
                        this.tenure = this.productDetailsList[0].tenure
                        this.price = this.productDetailsList[0].price
                        this.program_fee = this.productDetailsList[0].program_fee
                        //this.total_upfront = this.price + this.program_fee
                    } 
                    else {
                        this.messageBag = ['No record.'];
                        this.OrderSeen = false;
                    }
                })
                .catch(error => {
                    this.messageBag = [error.error];
                    this.OrderSeen = false;
                });
            },

            getDetail(){
                axios.get(process.env.VUE_APP_API_BASEURL+'customer/create/'+this.$route.params.id+'/'+this.$route.params.hash)
                .then(response => {
                    if (response) {
                        if(response.data.status=='error'){
                            this.messageBag = response.data.msj;
                        }else{
                            this.detail = response.data;
                            //console.log("Detail VAL",this.detail);
                            this.detailSeen  = true;
                            if (this.detail.last_name !== null){
                                this.email_name = this.detail.first_name + ' ' + this.detail.last_name;
                            }else{
                                this.email_name = this.detail.first_name;
                            }
                            this.firstName ='';

                            this.lastName = this.detail.last_name;
                            this.emailAddress = this.detail.email;
                            this.phoneNumber = this.detail.phone_number;
                            this.nric = this.detail.nric;
                            this.address = this.detail.address;
                            this.addressmix = this.detail.address+', '+this.detail.postalcode+', '+this.detail.city;
                            this.postalCode = this.detail.postalcode;
                            this.city = this.detail.city;
                            this.state = this.detail.state_id;
                            this.country = this.detail.country_id;

                            this.dateOfBirth = this.detail.dob;
                            this.gender = this.detail.gender;
                            this.tenure = this.detail.tenure;
                            this.phone_model = this.detail.phone_model;
                            this.store_name = this.detail.store_name;
                            // this.race_cus = this.detail.race_cus;
                            this.sku = this.detail.sku;

                            
                            this.getState(this.detail.country_id);
                            this.currentOtp(this.emailAddress);
                            
                        }
                        
                    } else {
                        this.messageBag = ['No record.'];
                        this.OrderSeen = false;
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                        this.OrderSeen = false;
                });
            },

            NumbersOnly(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            NameValidation(e){
                if(!e.key.match(/[^0-9.]/g,'ig'))
                {
                    e.preventDefault();
                }
            },

            checkingEmailValidation(){
                // eslint-disable-next-line
                var expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
           
                if (!expr.test(this.emailAddress)) {
                    alert('Please enter correct format');
                }
            },

            checkingNric(){
                if(this.renric.length==12){
                    this.checkblacklist();
                    this.loadNricStatus = true;
                    
                    axios.get(process.env.VUE_APP_API_BASEURL+'customer/checknric/'+this.renric+'/'+this.$route.params.id)
                    .then(response => {
                        // console.log('-----------------');
                        // console.log(process.env.VUE_APP_API_BASEURL+'customer/'+this.renric);
                        // console.log(response.data);
                        if (response) {
                           
                            this.Nric_msj ="NRIC matched";
                           
                            // console.log('-----------');
                            if (typeof response.data.status_id !== 'undefined') {
                                // this.loadNricStatus = false;
                                // this.Nric_msj =response.data.reason;
                             
                                this.canNricProceed = 1;
                                this.canProceed = this.canEmailProceed * this.canNricProceed;

                                this.canProceed = this.canProceed + 1;
                                if(this.canProceed >= '2'){
                                    this.disableUpload = false;
                                }
                                
                            }else{
                                console.log("fail")
                                this.Nric_msj =response.data.reason;
                                this.disableUpload = true;
                                if(typeof response.data.url !== 'undefined'){
                                    // alert(response.data.reason);
                                    alert("We're unable to proceed with your application. Kindly contact our support team at renew.plus@compasia.com");
                                    window.location.href=response.data.url;
                                }
                                
                            }
                            // this.loadNricStatus = false;
                           
                        } 
                    })
                        .catch(error => {
                            this.messageBag = [error.error];
                            this.OrderSeen = false;
                    });
                    // console.log(this.renric.length);
                   
                }
            },

            RequestCode(){
                // if(this.emailAddress.length>27){
                //     alert("Exceeded the maximum count (27 characters)");
                //     this.disableUpload = true;
                // }
                // else{
                this.canNricProceed = 1;
                this.canProceed = this.canEmailProceed * this.canNricProceed;

                this.canProceed = this.canProceed + 1;
                if(this.canProceed >= '2'){
                    this.disableUpload = false;
                }
                this.email_name = this.firstName;
                // eslint-disable-next-line
                var expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
           
                if (!expr.test(this.emailAddress)) {
                    alert('Please enter correct format');
                }else{
                    this.loadRequestCode = true;
                this.msjVerifycode='';
                this.id_veryfyId = '';
                const posting_ = { email: this.emailAddress,name:this.email_name };
                axios.post(process.env.VUE_APP_API_BASEURL+'customer/email', posting_)
                .then(response => {
                    if (response) {
                        // console.log(response.data);
                        this.msjVerifycode = response.data.msj;
                        this.abletoSendRequestVerify = false;
                        this.id_veryfyId= response.data.id
                    } else {
                        this.messageBag = ['No record.'];
                        this.abletoSendRequestVerify = true;
                    }
                    this.loadRequestCode=false;
                    // this.pausedFor5Seconds = false;
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                });
                
                this.count2nd += 1;
                this.count += 1;
                if(this.count >= 3) {
                    this.pausedFor5Seconds = true;
                    this.timerCount = 50;
                    this.timerEnabled = true;
                    setTimeout(() => {this.pausedFor5Seconds= false;}, 40*1000);
                    this.count = 0; 
                }
                if (this.count2nd == 6){
                        this.pausedFor6Seconds = true;
                    }
                }
            // }
            },
            emailVerifyCode(){
                this.msjRespon = '';
                const posting_ = { code: this.verification };
                axios.post(process.env.VUE_APP_API_BASEURL+'customer/verify/'+this.emailAddress+'/'+this.$route.params.id, posting_)
                .then(response => {
                    if(response.data.code == 1){
                        
                        this.canEmailProceed = 1;
                        this.canProceed = this.canEmailProceed * this.canNricProceed;
                        
                        if(this.canProceed == '1'){
                            this.disableUpload = false;
                        }
                    }
                    this.msjRespon = response.data.msj;
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                });
                
            },

            currentOtp(){
                axios.get(process.env.VUE_APP_API_BASEURL+'customer/check/'+this.$route.params.id)
                .then(response => {
                    if (typeof response.data.id !== 'undefined') {
                        if(response.data.otp_email_check  == 1){
                            this.abletoSendRequestVerify=false;
                            this.disableemailVeryfy=true;
                            this.canProceed = this.canProceed + 1;

                            
                            this.canEmailProceed = 1;
                            this.canProceed = this.canEmailProceed * this.canNricProceed;
                            
                            if(this.canProceed == '1'){
                                this.disableUpload = false;
                            }
                            
                            
                        }else{
                            this.abletoSendRequestVerify=true;
                            this.disableemailVeryfy=false;
                        }
                        
                    }
                });
            },

            refadd(){               
                this.error_refSeen=false;
                if(this.ref_name == ''){
                    this.error_ref_name = 'Please Enter Name';
                }else{
                    this.error_ref_name = '';
                }

                if(this.ref_number == ''){
                    this.error_ref_number = 'Please Enter Mobile Number';
                }else if (this.ref_number.length < 9) {
                    this.error_ref_number = 'Please Enter Minimum Length 9 Digit';
                }
                else{
                    this.error_ref_number = '';
                }

                if(this.relationship == ''){
                    this.error_ref_relationship = 'Please Select Relationship';
                }
                else{
                    this.error_ref_relationship = '';
                }

                const posting_ = { 
                    ref_name: this.ref_name, 
                    ref_number: this.ref_number, 
                    relationship: this.relationship, 
                    temp_id: this.$route.params.id, 
                };
                // console.log(posting_);
                if(this.ref_number.length < 9){
                    //ok
                }else{
                    axios.post(process.env.VUE_APP_API_BASEURL+'ref/create', posting_)
                    .then(response => {
                        if (response) {
                            this.ref_name = '';
                            this.relationship = '';
                            this.ref_number = '';
                            this.refList();
                        
                            axios.get(process.env.VUE_APP_API_BASEURL+'nric/'+this.customerId)
                            .then(response => {
                                if (response) {
                                    console.log(response);
                                    //alert(response.data);
                                    if(response.data == 1){
                                        console.log('Function refadd => Call API check NRIC (Line 669) : Front & Back NRIC is exist');
                                        this.disableTOFinance = false;
                                    }
                                } 
                                else {
                                    console.log('Function refadd => Call API check NRIC (Line 669) : No response recieved');
                                }
                            })
                            .catch(error => {
                                this.messageBag = [error.error];
                            });
                        
                        } 
                        else {
                            this.messageBag = ['No record.'];
                        }
                    })
                        .catch(error => {
                            this.messageBag = [error.error];
                    });
                    }
                
            },

            deleterefadd(id){   
                axios.get(process.env.VUE_APP_API_BASEURL+'ref/delete/'+id)
                .then(response => {
                    if (response) {
                        this.refList();
                    } else {
                        this.messageBag = ['Not Deleted'];
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                });
            },

            refList(){
                this.loadingListRef = true;
                axios.get(process.env.VUE_APP_API_BASEURL+'ref/list/temp/'+this.$route.params.id)
                .then(response => {
                    
                    this.refListing = response.data;
                    console.log("Reflisting",this.refListing.length);
                });
            },
            LoanList(){
                this.loadingListRef = true;
                axios.get(process.env.VUE_APP_API_BASEURL+'loan/list')
                .then(response => {
                    // console.log('xxifxx');
                    this.loanListing = response.data;
                    // console.log(this.data);
                    this.loadLoan=true;
                });
            },

            changeLocation(e){

                if(e.target.value == 'None'){
                    this.NetSalray=true;
                    this.UploadSlip=true;
                
                    this.salryRange = false;
                }else{
                    this.NetSalray=false;
                    this.UploadSlip=false;
                
                    this.salryRange = true;
                }
            },
            nolaoding(){
                this.loadingCreditCheck = false;
            },
            popupAlert() {
                Swal.fire({
                    imageUrl: require("@/assets/images/redirect_popup-2.png"),
                    imageHeight: 500,
                    imageWidth: 500,
                    imageAlt: "A tall image",
                    showConfirmButton: false,
                    buttonsStyling: false,
                    showCloseButton: true,
                });
            },
            checkingpopup(){
                Swal.fire({
                    title: 'Checking',
                    text:   "Please DO NOT close or refresh this page until the result is displayed",
                    icon: 'warning',
                    showConfirmButton: false,
                    // timer: 3000,
                    allowOutsideClick: false,
                }); 
            },
            uploadingpopup(){
                Swal.fire({
                    title: 'Uploading IC',
                    text:   "Please Wait.",
                    icon: 'warning',
                    showConfirmButton: false,
                }); 
            },

            cekFund(){
                this.loadingCreditCheck = true;
                // alert(this.companyname);
                var expr = /^\d{1,6}(?:\.\d{0,2})?$/;
                var exprdot = /^\d{1,6}(?:\.)?$/;
                this.canProceed = 1;
                
                if(this.companyname ==''||this.companyname == null){
                    this.canProceed = this.canProceed * 0;
                    this.error_companyname ='Please Enter Company Name';
                    this.loadingCreditCheck =false;
                }
                else{
                    this.error_companyname ='';
                }

                if(this.general_line ==''||this.general_line ==null){
                    this.canProceed = this.canProceed * 0;
                    this.error_general_line ='Please Enter General Line';
                    this.loadingCreditCheck =false;
                }
                else if(this.general_line.length < 9){
                    this.canProceed = this.canProceed * 0;
                    this.error_general_line ='Please Enter Maximum Length 10 Digit';
                    this.loadingCreditCheck =false;
                }
                else{
                    this.error_general_line ='';
                }

                if(this.salary_range ==''||this.salary_range ==null){
                    this.loadingCreditCheck =false;
                    this.error_salary_range ='Please Enter Salary Range';
                }
                else{
                    this.error_salary_range ='';
                }

                if(this.net_salary ==''||this.net_salary ==null){
                    this.loadingCreditCheck =false;
                    this.error_net_salary ='Please Enter Net Salary';
                }
                else if(!expr.test(this.net_salary)){
                    this.loadingCreditCheck =false;
                    this.error_net_salary ='Please Enter Correct Salary Format';
                }
                else if(exprdot.test(this.net_salary)){
                    this.loadingCreditCheck =false;
                    this.error_net_salary ='Please Enter Correct Salary With 2 Decimal Places';
                }
                else{
                    this.error_net_salary ='';
                }

                if(this.PersonalLoan == '' && this.CreditCard == '' && this.CarLoan== '' && this.Housing== '' && this.loan_none== ''){
                    this.loadingCreditCheck =false;
                    this.canProceed = this.canProceed * 0;
                    this.error_loan ='Please Select Credit Facility';
                }
                else{
                    this.error_loan ='';
                }
                if(this.uploadPayslip_){
                    this.error_uploadPayslip_='';
                }
                else{
                    this.loadingCreditCheck =false;
                    this.error_uploadPayslip_ ='Please Upload Payslip';
                    // alert("Please Upload Payslip")
                }

                if(this.canProceed == 0){
                    return false;
                }

                if( this.companyname == '' || this.general_line =='' || this.general_line.length < 9){
                    this.loadingCreditCheck = false;
                }
                else
                {
                    if( this.loan_none)
                    {   //if select none
                        this.saveDataUpload();      
                    }
                    else{
                        this.saveData();
                    }

                    this.succespg = true;
                    this.emplypg = true;
                    
                    this.loadingCreditCheck = false;
                    if( this.loan_none)
                    {   //if select none                  
                        this.loadingCreditCheck = true;
                    }
                }                          
            }, 

            tocurlect(){
                // alert(this.customerId);
                // var data = JSON.stringify({
                //     "customerId": 1,
                //     "typeofIdentity": "NRIC",
                //     "amount": 3000,
                //     "effectiveDate": "2022-11-16",
                //     "bankId": 19
                // });
                //window.location.href = 'http://localhost:8080/customer/mandate/auth/'+this.OrderId+'/64faf19fe2ee24256c882ed3853ea914cd7f77c443371b6ae0cf696a3aeaa06a';

                if(this.firstName == ''){
                    alert("Please Enter Name")
                }
                else
                {
                    const posting_ = { 
                        temporayaddress: this.temporayaddress,
                        postalCodetemp:this.postalCodetemp, 
                        citytemp:this.citytemp, 
                        statetemp:this.statetemp, 
                        countrytemp:this.countrytemp, 
                        namenric:this.firstName,
                        applicationsource:this.aplicationsource,
                        race_cus:this.race_cus,
                        emailAddress : this.emailAddress
                    };
                    axios.post(process.env.VUE_APP_API_BASEURL+'customer/step1/'+this.$route.params.id, posting_)
                    .then(response => {
                        if (response) {
                            // console.log(response.data);
                            if(response.data.status == 'successfully'){
                                console.log("Success");
                            }
                            else{
                                console.log('fail to save data');
                            }
                        } 
                        else {
                            this.messageBag = ['No record.'];
                            this.abletoSendRequestVerify = true;
                        }
                        this.loadRequestCode=false;
                    })
                    .catch(error => {
                        this.messageBag = [error.error];
                    });

                    if (this.bank){
                        const grandTotal = this.price+this.program_fee;
                        const Todaydate = new Date().toJSON().slice(0, 10);
                        var dataTocurlec = JSON.stringify({
                            "customerId": this.customerId,
                            "typeofIdentity": "NRIC",
                            "amount": grandTotal,
                            "effectiveDate": Todaydate,
                            "bankId": this.bank.toString().replace(/['"]+/g, '')
                        });

                        console.log(dataTocurlec);
                        var hasingVar = this.$route.params.hash;
                        var idVar = this.OrderId;
                        var config = {
                            method: 'post',
                            url: process.env.VUE_APP_API_NODEJS+'/v2/generateMandateLink',
                            headers: { 
                                'Content-Type': 'application/json'
                            },
                            data : dataTocurlec
                        };

                        axios(config)
                        .then(function (response) {
                            if (typeof response.data.url !== 'undefined') {
                                window.location.href = response.data.url;
                            }
                            else{
                                if (typeof response.data.message !== 'undefined') {
                                    alert(response.data.message);
                                }
                            }
                            // console.log(JSON.stringify(response.data));
                        })
                        .catch(function (error) 
                        {
                            if (error.response) 
                            {
                                Swal.fire({
                                    title: error.response.data.message,
                                    icon: "warning",
                                    confirmButtonColor: "#f46a6a",
                                }).then((result) => {
                                    if (result.value) 
                                    {
                                        axios.get(process.env.VUE_APP_API_BASEURL+'session/timeout/sent/'+idVar+'/'+hasingVar+'/'+error.response.data.message)
                                        .then(response => {
                                            if (response) {
                                                if (typeof response.data.url !== 'undefined') {
                                                    window.location.href=response.data.url;
                                                }
                                            } else {
                                                this.messageBag = ['No record.'];
                                                this.OrderSeen = false;
                                            }
                                        })
                                            .catch(error => {
                                                this.messageBag = [error.error];
                                                this.OrderSeen = false;
                                        });
                                    }
                                });
                            }
                            console.log(error);
                        });
                    }
                    else{
                        alert("Please select bank")
                    }
                }           
            },

            
            saveData(){
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                this.loantogether='';
                
                if(this.PersonalLoan == true){
                    this.loantogether='Personal Loan'+', ';
                }
                if(this.CreditCard == true){
                    this.loantogether='Credit Card, '+this.loantogether;
                }

                if(this.CarLoan == true){
                    this.loantogether='Car Loan, '+this.loantogether;
                }

                if(this.Housing == true){
                    this.loantogether='Housing Loan, '+this.loantogether;
                }

                const posting_ = { 
                    companyname: this.companyname,
                    general_line: this.general_line,
                    salary_range: this.salary_range,
                    loan:this.loantogether,
                    // net_salary: this.net_salary,
                    // payslip: this.payslip
                };
                axios.post(process.env.VUE_APP_API_BASEURL+'customer/create/'+this.$route.params.id+'/normal'+this.$route.hash, posting_)
                .then(response => {
                    if (response) {
                        // console.log(response.data);
                        if(response.data.status =='successfully'){
                            // alert('Create Customer Successfully');
                            
                            const elem = document.getElementById('pills-success-tab');
                            elem.click(); 
                        }else{
                            alert('create data fail');
                        }
                    } else {
                        this.messageBag = ['No record.'];
                        this.OrderSeen = false;
                    }
                })
                    .catch(error => {
                        this.messageBag = [error.error];
                        this.OrderSeen = false;
                });

                // if(this.CarLoan == true){
                //     this.DisableCheckboxNone=false;
                // }else{
                //     this.DisableCheckboxNone=true;
                // }

                // if(this.Housing == true){
                //     this.DisableCheckboxNone=false;
                // }else{
                //     this.DisableCheckboxNone=true;
                // }

                // console.log(this.loan_none);
                // if(this.loan_none == true){
                //     console.log('11');
                //     this.DisableCheckbox=false;
                // }else{
                //     console.log('22');
                //     this.DisableCheckbox=true;
                // }

            },
            tncproceed(){
                
              this.disableTncs = false;
            },  


            //upload file
            uploadFilefrontic(){
                // canProceedNric
                this.frontapprove = 1;
                this.frontic = this.$refs.frontic.files[0];
                
                if (this.frontic.size >= 5120000) {
                    //this.disableTOFinance =true;
                    // Notification here
                    Swal.fire({
                        title: 'Your Picture Size Is Too Large',
                        text:   "Picture with size less than 5MB only can be proceed to next page",
                        icon: 'warning',
                        showConfirmButton: true,
                    }); 
                
                }else{
                    /*Swal.fire({
                        title: 'Error Uploading',
                        text:   "Try Again",
                        icon: 'warning',
                        showConfirmButton: true,
                    });*/ 
                    var newFileName = this.frontic.name.replace(/\s+/g, '').toLowerCase();
                    this.loadingUploadFrontNRIC=true;
                    let formData = new FormData();
                    //formData.append('fontic', this.frontic);
                    formData.append('fontic', this.frontic, newFileName);
                    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
                    axios.post(process.env.VUE_APP_API_BASEURL+'customer/upload/nric/front/'+this.customerId,
                        formData,
                        {
                            headers: {
                                'Content-Type':'multipart/form-data',
                                'Access-Control-Allow-Origin':'*'
                            }
                        }
                    ).then(response => {
                        if (response) {
                            this.loadingUploadFrontNRIC=false;
                            console.log(response);
                            this.uploadresult = response.data;
                            
                            if(this.uploadresult.status == 'error'){
                                Swal.fire({
                                    title: 'Error Uploading',
                                    text:  this.uploadresult.message,
                                    icon:  'warning',
                                    showConfirmButton: true,
                                });
                            }
                            else{
                                console.log('Function uploadFilebacktic => Call API post front NRIC (Line 1209) : Success Upload');
                                this.success_upload_fNric = this.uploadresult.status;
                                this.success_upload_msg = this.uploadresult.message;

                                //buat checking front & back NRIC dah ada kat backend ke x. 
                                axios.get(process.env.VUE_APP_API_BASEURL+'nric/'+this.customerId)
                                .then(response => {
                                    if (response) {
                                        console.log(response);
                                        //alert(response.data);
                                        if(response.data == 1){
                                            if (typeof this.refListing['0'] == 'undefined') {
                                                console.log('Function uploadFilebacktic => Front & Back NRIC exist, but references data added');
                                            }
                                            else{
                                                this.disableTOFinance = false;
                                            }
                                        }
                                    } 
                                    else {
                                        console.log('No response');
                                    }
                                })
                                .catch(error => {
                                    this.messageBag = [error.error];
                                });
                            }
                        } 
                        else {
                            console.log('Function uploadFilefrontic => Call API post front NRIC (Line 1135) : No response recieved');
                        }
                    })
                    .catch(error => {
                        this.messageBag = [error.error];
                    });
                }
                // console.log(this.canProceedNric);
            },

            uploadFilebacktic(){
                this.backapprove = 1;
                this.backic = this.$refs.backic.files[0];
                
                if (this.backic.size >= 5120000) {
                    //this.disableTOFinance =true;
                    // Notification here
                    Swal.fire({
                        title: 'Your Picture Size Is Too Large',
                        text:   "Picture with size less than 5MB only can be proceed to next page",
                        icon: 'warning',
                        showConfirmButton: true,
                    }); 
                }
                else{
                    var newFileName = this.backic.name.replace(/\s+/g, '').toLowerCase();
                    this.loadingUploadBackNRIC=true;
                    let formData = new FormData();
                    //formData.append('backic', this.backic);
                    formData.append('backic', this.backic, newFileName);
                    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
                    axios.post(process.env.VUE_APP_API_BASEURL+'customer/upload/nric/back/'+this.customerId,
                        formData,
                        {
                            headers: {
                                'Content-Type':'multipart/form-data',
                                'Access-Control-Allow-Origin':'*'
                            }
                        }
                    ).then(response => {
                        if (response) {
                            this.loadingUploadBackNRIC=false;
                            console.log(response);
                            this.uploadresult2 = response.data;
                            if(this.uploadresult2.status == 'error'){
                                Swal.fire({
                                    title: 'Error Uploading',
                                    text:  this.uploadresult2.message,
                                    icon:  'warning',
                                    showConfirmButton: true,
                                });
                            }
                            else{
                                console.log('Function uploadFilebacktic => Call API post back NRIC (Line 1209) : Success Upload');
                                this.success_upload_bNric = this.uploadresult2.status;
                                this.success_upload_bNric_msg = this.uploadresult2.message;

                                //buat checking front & back NRIC dah ada kat backend ke x. 
                                axios.get(process.env.VUE_APP_API_BASEURL+'nric/'+this.customerId)
                                .then(response => {
                                    if (response) {
                                        console.log(response);
                                        if(response.data == '1'){
                                            if (typeof this.refListing['0'] == 'undefined') {
                                                console.log('Function uploadFilebacktic => Front & Back NRIC exist, but references data added');
                                            }
                                            else{
                                                this.disableTOFinance = false;
                                            }
                                        }
                                    } 
                                    else {
                                        console.log('No response');
                                    }
                                })
                                .catch(error => {
                                    this.messageBag = [error.error];
                                });
                            }
                        } 
                        else {
                            console.log('Function uploadFilebacktic => Call API post back NRIC (Line 1209) : No response recieved');
                        }
                    })
                    .catch(error => {
                        this.messageBag = [error.error];
                    });
                }
                // console.log(this.canProceedNric);
            },

            /*submitFile() {
                if(this.uploadRetry<=5){
                    // console.log(this.uploadRetry+'--------');
                    document.body.scrollTop = 0;
                    document.documentElement.scrollTop = 0;
                    this.error_name_ref='';
                    this.error_refSeen=false;

                    // console.log(this.refListing['0']);
                    // console.log('-------------');
                    if (typeof this.refListing['0'] == 'undefined') {
                        this.error_refSeen=true;
                        this.error_name_ref ='Please Add References Information';
                    }else{
                        const elem = document.getElementById('pills-info-warning-tab');
                        elem.click(); 
                        const formData = new FormData();
                        
                        formData.append(
                            'fontic', this.frontic
                        );

                        formData.append(
                            'backic', this.backic
                        );
                        const headers = { 'Content-Type': 'multipart/form-data', 'Access-Control-Allow-Origin':'*' };
                        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
                        axios.post(process.env.VUE_APP_API_BASEURL+'customer/upload/nric/'+this.customerId, formData, { headers }).then((res) => {
                            // res.data.files; // binary representation of the file
                            // res.status; // HTTP status
                            // console.log(res);
                            if(res.data.status== 'successfully'){
                                this.disableTOFinance=false;
                                
                            }
                            if (typeof res.data.status !== 'undefined') {
                                if(res.data.status!= 'successfully'){
                                    this.uploadRetry = this.uploadRetry+1;
                                    // console.log(this.uploadRetry+'*********');
                                    this.submitFile();
                                }   
                            }
                            
                        });
                    }
                }
            },*/

            submitFile() {
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                this.error_name_ref='';
                this.error_refSeen=false;

                if (typeof this.refListing['0'] == 'undefined') {
                    this.error_refSeen=true;
                    this.error_name_ref ='Please Add References Information';
                }else if (this.refListing.length < 2) {
                    this.error_refSeen=true;
                    this.error_name_ref ='Please Add 2 References Information ';
                }else{
                    const elem = document.getElementById('pills-info-warning-tab');
                    elem.click();
                }
            },

            uploadPayslipF(){
                this.uploadPayslip_ = this.$refs.uploadPayslip.files[0];
            },

            saveDataUpload(){
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                

                const posting_No = { 
                    net_salary: this.net_salary,
                    companyname:this.companyname, 
                    general_line:this.general_line, 
                    loan:this.None,
                };

                axios.post(process.env.VUE_APP_API_BASEURL+'customer/create/'+this.$route.params.id+'/no_upload', posting_No).then(() => {
                    
                    var newFileName = this.uploadPayslip_.name.replace(/\s+/g, '').toLowerCase();
                    const formData = new FormData();
                    formData.append(
                        'uploadPayslip', this.uploadPayslip_,newFileName
                    );

                    formData.append(
                        'net_salary', this.net_salary,
                    );

                    formData.append(
                        'companyname', this.companyname,
                    );

                    formData.append(
                        'general_line', this.general_line,
                    );

                    formData.append(
                        'loan', 'None',
                    );

                    const headers = { 'Content-Type': 'multipart/form-data', 'Access-Control-Allow-Origin':'*' };
                    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
                    axios.post(process.env.VUE_APP_API_BASEURL+'customer/create/'+this.$route.params.id+'/upload', formData, { headers }).then(() => {
                        const elem = document.getElementById('pills-success-tab');
                        elem.click(); 
                    });
                    
                });
            },
            //end of upload file

           
        },
        watch: {

            timerCount: {
                handler(value) {

                    if (value > 0) {
                        setTimeout(() => {
                            this.timerCount--;
                        }, 8*100);
                    }

                },
                immediate: true // This ensures the watcher is triggered upon creation
            }
        },  

        
        components: {
            // lottie: Lottie
            //TermsConditionsModal,
            EmandateModal

        },
        mounted(){
            this.popupAlert();
            this.getDetail();
            this.getCustomer();
            this.getCountry();
            this.getRelationList();
            this.refList();
            this.LoanList();
            this.getState();
            this.getBank();
            this.getProductDetails();
            document.querySelector("#profile-img-file-input").addEventListener("change", function () {
                var preview = document.querySelector(".user-profile-image");
                var file = document.querySelector(".profile-img-file-input").files[0];
                var reader = new FileReader();

                reader.addEventListener(
                    "load",
                    function () {
                        preview.src = reader.result;
                    },
                    false
                );

                if (file) {
                    reader.readAsDataURL(file);
                }
            });

            document.querySelector("#profile-img-file-inputa").addEventListener("change", function () {
                var preview = document.querySelector(".user-profile-imagea");
                var file = document.querySelector(".profile-img-file-inputa").files[0];
                var reader = new FileReader();

                reader.addEventListener(
                    "load",
                    function () {
                        preview.src = reader.result;
                    },
                    false
                );

                if (file) {
                    reader.readAsDataURL(file);
                }
            });
            
            document.querySelectorAll(".form-steps").forEach(function (form) {

                // next tab
                form.querySelectorAll(".nexttab").forEach(function (nextButton) {
                    var tabEl = form.querySelectorAll('button[data-bs-toggle="pill"]');
                    tabEl.forEach(function (item) {
                        item.addEventListener('show.bs.tab', function (event) {
                            event.target.classList.add('done');
                        });
                    });
                    nextButton.addEventListener("click", function () {
                        var nextTab = nextButton.getAttribute('data-nexttab');
                        document.getElementById(nextTab).click();
                    });
                });

                //Pervies tab
                form.querySelectorAll(".previestab").forEach(function (prevButton) {

                    prevButton.addEventListener("click", function () {
                        var prevTab = prevButton.getAttribute('data-previous');
                        var totalDone = prevButton.closest("form").querySelectorAll(".custom-nav .done").length;
                        for (var i = totalDone - 1; i < totalDone; i++) {
                            (prevButton.closest("form").querySelectorAll(".custom-nav .done")[i]) ? prevButton.closest("form").querySelectorAll(".custom-nav .done")[i].classList.remove('done'): '';
                        }
                        document.getElementById(prevTab).click();
                    });
                });

                // Step number click

                var tabButtons = form.querySelectorAll('button[data-bs-toggle="pill"]');
                tabButtons.forEach(function (button, i) {
                    button.setAttribute("data-position", i);
                    button.addEventListener("click", function () {
                        var getProgreebar = button.getAttribute("data-progressbar");
                        if (getProgreebar) {
                            var totallength = document.getElementById("custom-progress-bar").querySelectorAll("li").length - 1;
                            var current = i;
                            var percent = (current / totallength) * 100;
                            document.getElementById("custom-progress-bar").querySelector('.progress-bar').style.width = percent + "%";
                        }
                        (form.querySelectorAll(".custom-nav .done").length > 0) ?
                        form.querySelectorAll(".custom-nav .done").forEach(function (doneTab) {
                            doneTab.classList.remove('done');
                        }): '';
                        for (var j = 0; j <= i; j++) {
                            tabButtons[j].classList.contains('active') ? tabButtons[j].classList.remove('done') : tabButtons[j].classList.add('done');
                        }
                    });
                });


                
                
             
                

            });
        }
    };
</script>

<style >
    .swal2-close:focus {
        box-shadow: none !important;
    }
    
    #container{
    padding-top:20px;
    margin-top:20px;
    width:100vw;
    color:white;
    background-color:#003E30;
    display:flex;
    flex-direction:column;
    align-items:center;
    position:fixed;
    bottom:0;
    }
    #contacts{
    display:flex;
    justify-content:space-around;
    align-items:center;
    width:100%;
    }
    #contacts--contact{
    text-align:right;
    }
    #contacts--social{
    width:20%;
    display : flex;
    justify-content : space-between;
    }
    #contacts--social div{
    height:30px;
    width:30px;
    background-color:white;
    border-radius:50%;
    }
    #mentions p {
    font-size:0.5em;
    }
    .card {
    margin-bottom: -9.5rem !important;
    }
    .avatar-title {
        background-color: #695eef00 !important;
        padding: 180px;
        cursor: pointer;
    }
    /* .progress-nav .progress {
        position: absolute;
        left: 0;
        top: 50%;
        transform: rotate(-90deg);
        width: 100%;
    }    
        
    .progress-nav .nav {
        margin-right: -1rem;
        margin-left: -1rem;
        justify-content: space-between;
        transform: rotate(90deg);
    }
        
    .progress-nav .nav .nav-link {
        width: 2rem;
        height: 2rem;
        background-color: var(--vz-light);
        padding: 0;
        color: var(--vz-dark);
        font-weight: 400;
        transform: rotate(-90deg);
    } */
    .dt-show{
        display: block;
    }
    .mb-show{
        display: none;
    }
    @media (min-width: 320px) and (max-width: 500px){
        .col-9 {
            width: 100%;
        }
        .progress-nav .progress {
                position: absolute;
                /* left: -661.8%;
                top: 49%;
                width: 1329%;
                transform: rotate(90deg); */
           }

        .dt-show{
        display: none;
        }
        .mb-show{
        display: block;
        }
        .mt-mbr{
            margin-top: 3rem;
        }
        td {
            word-wrap: break-word !important;
           }
       }
    @media (min-width: 2001px) and (max-width: 2500px){
           
           .progress-nav .progress {
               position: absolute;
               transform: rotate(90deg);
               left: -14.7rem;
           }
           /* .progress-nav {
               padding-left: 13rem;
           } */
       }
 
    @media (min-width: 1920px) and (max-width: 2000px){
           
        .progress-nav .progress {
            position: absolute;
            transform: rotate(90deg);
        }
        .progress-nav {
            padding-left: 13rem;
        }
    }

    @media (min-width: 1280px) and (max-width: 1919px){
           
           .progress-nav .progress {
            position: absolute;
            left: -83.8%;
            top: 49%;
            width: 169%;
            transform: rotate(90deg);
           }
       }
        

    .tabinfo{
        font-size: 16px;
        white-space: nowrap;
        margin-top: 5px;
        padding-left: 5px;
    }
    .fixed-top {
        background-color: #F3F4F6 !important;
    }
    .navbar {
    padding-top: 0px !important;
    /* padding-bottom: 0px !important; */
    }
    .container-fluid{
    padding-right: 0px !important;
    padding-left: 0px !important;
    }
    .progress-nav .nav .nav-link.active, .progress-nav .nav .nav-link.done {
    background-color: #77BF4C !important;
    }
    .progress-bar {
        background-color: #77BF4C !important;
    }
    .pt-tab {
    padding-top: 7rem;
    }
    .btn-primary:hover {
        color: #fff;
        background-color: #77BF4C;
        border-color: #77BF4C;
    }
    .btn {
        color: #fff;
        background-color: #77BF4C !important;
        border-color: #77BF4C !important;
    }
    .form-check-input:checked {
        background-color: #77bf4c !important;
        border-color: #77bf4c !important;
    }
    .border-top {
    border-top: 1px solid #fff !important;
    }
</style>

<template>
    <div class="layout-wrapper landing">

        <nav class="navbar navbar-expand-lg fixed-top" id="navbar">
            <div class="container">
                <a class="navbar-brand" href="index.html">
                    <img style="width: 95px" src="https://renewp.compasia.com/assets/images/logo.png" class="img-fluid card-logo card-logo-dark" alt="logo dark" >
                    <img src="https://renewp.compasia.com/assets/images/logo.png" class="card-logo card-logo-light" alt="logo light" >
                </a>
            </div>
        </nav>

        <section class="section pb-0 hero-section" id="hero" >
        <!-- start hero section -->
            <!-- <div class="bg-overlay bg-overlay-pattern"></div> -->
            <div class="container-fluid" style="overflow-x: hidden;">

                <div class="">
                    <!-- <div class="card-header align-items-center d-flex">
                        <h4 class="card-title mb-0 flex-grow-1">Customer Register</h4>
                    </div> -->
                    <div class="card-body form-steps mt-mbr">

                        <form action="#">
                                    <div id="custom-progress-bar" class="progress-nav mb-4 mb-show">
                                        <div class="progress" style="height: 1px;">
                                            <div class="progress-bar" role="progressbar" style="width: 0%;" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>

                                        <ul class="nav nav-pills progress-bar-tab custom-nav" role="tablist">
                                            <li class="nav-item" role="presentation">
                                                    <button style="pointer-events: none;" class="nav-link rounded-pill active" data-progressbar="custom-progress-bar" id="pills-gen-info-tab" data-bs-toggle="pill" data-bs-target="#pills-gen-info" type="button" role="tab" aria-controls="pills-gen-info" aria-selected="true">1</button>
                                            </li>
                                            
                                            <li class="nav-item" role="presentation">
                                                    <button style="pointer-events: none;" :disabled='disableUpload' class="nav-link rounded-pill" data-progressbar="custom-progress-bar" id="pills-info-desc-tab" data-bs-toggle="pill" data-bs-target="#pills-info-desc" type="button" role="tab" aria-controls="pills-info-desc" aria-selected="false">2</button>
                                            </li>
                                            <li class="nav-item" role="presentation">
                                                    <button style="pointer-events: none;" :disabled="disableTOFinance" class="nav-link rounded-pill" data-progressbar="custom-progress-bar" id="pills-info-warning-tab" data-bs-toggle="pill" data-bs-target="#pills-warning-desc" type="button" role="tab" aria-controls="pills-warning-desc" aria-selected="false">3</button>
                                            </li>
                                            <li class="nav-item" role="presentation">
                                                    <button style="pointer-events: none;" class="nav-link rounded-pill" data-progressbar="custom-progress-bar" id="pills-success-tab" data-bs-toggle="pill" data-bs-target="#pills-success" type="button" role="tab" aria-controls="pills-success" aria-selected="false">4</button>
                                            </li>
                                        </ul>
                                    </div>
                        <div class="row">
                            <div class="col-3 pt-5 dt-show">
                                <div id="custom-progress-bar" class="progress-nav">
                                    <div class="progress" style="height: 1px;">
                                        <div class="progress-bar progress-bar-striped" role="progressbar" style="width: 0%;" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                                    </div>
                                <!--    class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical" -->
                                <ul class="nav nav-pills progress-bar-tab custom-nav d-flex flex-column" role="tablist">
                                        <li class="nav-item d-flex" role="presentation">
                                        
                                                <button style="pointer-events: none;" class="nav-link rounded-pill active" data-progressbar="custom-progress-bar" id="pills-gen-info-tab" data-bs-toggle="pill" data-bs-target="#pills-gen-info" type="button" role="tab" aria-controls="pills-gen-info" aria-selected="true">1</button>
                                                <span class="tabinfo">Personal Information</span>
                                            
                                        </li>
                                        
                                        <li class="nav-item pt-tab d-flex" role="presentation">
                                        
                                                <button style="pointer-events: none;" :disabled="disableTOFinance" class="nav-link rounded-pill" data-progressbar="custom-progress-bar" id="pills-info-desc-tab" data-bs-toggle="pill" data-bs-target="#pills-info-desc" type="button" role="tab" aria-controls="pills-info-desc" aria-selected="false">2</button>
                                                <span class="tabinfo">References Information</span>
                                        
                                        </li>
                                        <li class="nav-item pt-tab d-flex" role="presentation">
                                        
                                                <button class="nav-link rounded-pill" data-progressbar="custom-progress-bar" id="pills-info-warning-tab" data-bs-toggle="pill" data-bs-target="#pills-warning-desc" type="button" role="tab" aria-controls="pills-warning-desc" aria-selected="false">3</button>
                                                <span class="tabinfo">Employment Information</span>
                                        
                                        </li>
                                        <li class="nav-item pt-tab d-flex" role="presentation">
                                            
                                            
                                                <button style="pointer-events: none;" class="nav-link rounded-pill" data-progressbar="custom-progress-bar" id="pills-success-tab" data-bs-toggle="pill" data-bs-target="#pills-success" type="button" role="tab" aria-controls="pills-success" aria-selected="false">4</button>
                                                <span class="tabinfo">Confirm Order</span>
                                    
                                        </li>
                                        <!-- <li class="nav-item pt-tab d-flex" role="presentation" style="display: none !important;">
                                            
                                            
                                            <button class="nav-link rounded-pill" data-progressbar="custom-progress-bar" id="pills-confirm-desc-tab" data-bs-toggle="pill" data-bs-target="#pills-confirm-desc" type="button" role="tab" aria-controls="pills-confirm-desc" aria-selected="false">5</button>
                                            <span class="tabinfo">Select Bank</span>
                                
                                        </li>
                                        <li class="nav-item pt-tab d-flex" role="presentation" style="display: none !important;">
                                            
                                            
                                            <button class="nav-link rounded-pill" data-progressbar="custom-progress-bar" id="pills-auth-desc-tab" data-bs-toggle="pill" data-bs-target="#pills-auth-desc" type="button" role="tab" aria-controls="pills-auth-desc-tab" aria-selected="false">6</button>
                                            <span class="tabinfo">Authorized</span>
                                
                                        </li> -->
                                    </ul>
                                    
                                    
                        
                                </div>
                        
                            </div>
                            <div class="col-9 pb-5">
                                <div class="tab-content">
                                <div class="tab-pane fade show active pt-5 pb-5" id="pills-gen-info" role="tabpanel" aria-labelledby="pills-gen-info-tab">
                                
                                    <fieldset class="form-group border p-3">
                                        <legend class="w-auto px-2">Personal Information</legend>
                                        <div class="row gy-4" v-if="detailSeen">
                                            <div class="col-md-6">
                                                <div>
                                                    <label for="placeholderInput" class="form-label">Application Source</label>
                                                    <select v-model="aplicationsource" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Gender" disabled>
                                                        <option value="">Please Select Application Source</option>
                                                        <option value="Online Application">
                                                            Online Application
                                                        </option>
                                                        <option value="In Store Application">
                                                            In Store Application
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-12">
                                                <div>
                                                    <label for="basiInput" class="form-label">Name as per NRIC</label>
                                                    <input type="text" class="form-control" v-on:keypress="NameValidation" v-model="firstName">
                                                    <span style="color: #b7afaf;">
                                                     e.g. Amir Radzi Bin Muhammad Shamim
                                                    </span> 
                                                </div>
                                            </div>
                                            <!--end col-->

                                            <div class="col-md-6">
                                                <div>
                                                    <label for="placeholderInput" class="form-label">NRIC</label>
                                                    <input type="text" class="form-control" v-model="nric" disabled>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <label for="placeholderInput" class="form-label">Re-enter NRIC<span style="color: red;">*</span></label>
                                                <input type="text" class="form-control" placeholder="Re-enter NRIC No" @paste.prevent v-model="renric" v-on:keyup="checkingNric" v-on:keypress="NumbersOnly" maxlength="12" required>  
                                                <div v-if="Nric_msj">
                                                    <span style="color: red;" v-if="Nric_msj =='NRIC not matched'">
                                                        {{ Nric_msj }}
                                                    </span> 
                                                    <span style="color: green;" v-if="Nric_msj =='NRIC matched'">
                                                        {{ Nric_msj }}
                                                    </span> 
                                                </div> 
                                                <!-- <input type="text" class="form-control" v-model="renric" v-on:keypress="NumbersOnly" disabled>  -->
                        
                                            </div>
                                            <div class="col-md-6">
                                                <div>
                                                    <label for="placeholderInput" class="form-label">Mobile Number</label>
                                                    <input type="email" class="form-control" maxlength="10" minlength="9" v-model="phoneNumber" disabled>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div>
                                                    <label for="placeholderInput" class="form-label">Date Of Birth</label>
                                                    <input type="date" class="form-control" v-model="dateOfBirth" disabled>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div>
                                                    <label for="placeholderInput" class="form-label">Gender</label>
                                                    <select v-model="gender" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Gender" disabled>
                                                        <option value="Male">
                                                            Male
                                                        </option>
                                                        <option value="Female">
                                                            Female
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div>
                                                    <label for="placeholderInput" class="form-label">Race<span style="color: red;">*</span></label>
                                                    <select v-model="race_cus" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Race" required>
                                                        <option v-if="race_cus==null || race_cus=='' || race_cus=='null'" value="">
                                                           Please Select Race
                                                        </option>
                                                        <option value="Bumiputera">
                                                            Bumiputera
                                                        </option>
                                                        <option value="Chinese">
                                                            Chinese
                                                        </option>
                                                        <option value="Indian">
                                                            Indian
                                                        </option>
                                                        <option value="Others">
                                                            Others
                                                        </option>
                                                    </select>

                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                            
                                                <label for="placeholderInput" class="form-label"> Email <span style="color: red;">*</span></label>
                                                <div class="input-group" style="z-index: 0;">
                                                    <input type="email" class="form-control" v-model="emailAddress"  aria-label="Recipient's username with two button addons" v-on:keyup="emaillengthlimit">
                                                    <!-- <button class="btn btn-primary" type="button" v-if="abletoSendRequestVerify"  @click='RequestCode'>Request Code</button>  -->
                                                    <button class="btn btn-primary" type="button" :disabled="pausedFor5Seconds || pausedFor6Seconds"  @click='RequestCode'>Request Code</button> 
                                                
                                                </div>
                                                <span style="color: red;" v-if='loadRequestCode'>
                                                    <div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div>
                                                </span>
                                                <span style="color: #088675;" v-if="msjVerifycode !=''">
                                                    {{ msjVerifycode }}
                                                </span> 
                                                <br>
                                                <span style="color: #D7503E;" v-if='pausedFor5Seconds'>
                                                    Retry after {{ timerCount }} seconds
                                                </span> 
                                                <span style="color: #D7503E;" v-if='count2nd == 6 && timerCount ==0'>
                                                    Please try again later
                                                </span> 
                                            
                                                
                                                
                                            </div>
                                            <div class="col-md-6">
                                                <label for="placeholderInput" class="form-label">Email Verification Code <span style="color: red;">*</span></label>
                                                <div class="input-group">

                                                    <input type="email" class="form-control" v-model="verification" v-on:keyup="emailVerifyCode" maxlength='6' placeholder="Enter Verification Code"  required v-on:keypress="NumbersOnly">
                                                    <!-- <button class="btn btn-primary" type="button" v-if="abletoSendRequestVerify" @click='RequestCode' >Verify</button>  -->
                                                </div>
                                                <div v-if="msjRespon !=''" >
                                                    <span style="color: green;" v-if="msjRespon ==='Verification Code Match'">
                                                    {{ msjRespon }}
                                                    </span>
                                                    <span style="color: red;" v-else>
                                                        {{ msjRespon }}
                                                    </span> 
                                                </div>
                                            </div>
                                    
                                            <label for="placeholderInput" class="form-label" style="font-size: 20px;">Correspondent Address</label>
                                            <div class="col-md-6">
                                                <div>
                                                    <label for="placeholderInput" class="form-label">Address</label>
                                                    <textarea class="form-control" v-model="addressmix" rowspan="10" disabled> </textarea>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                            
                                            <label for="placeholderInput" class="form-label">Zip/Postal</label>
                                            <div class="input-group">
                                                <input type="text" class="form-control" v-model="postalCode" v-on:keypress="NumbersOnly" maxlength="10" aria-label="Recipient's username with two button addons" disabled>
                                            </div>
                                            
                                        </div>
                                            <div class="col-md-4">
                                            
                                            <label for="placeholderInput" class="form-label"> City</label>
                                            <div class="input-group">
                                                <input type="text" class="form-control" v-model="city" aria-label="Recipient's username with two button addons" disabled>
                                            </div>
                                            
                                        </div>
                                        <div class="col-md-4">
                                            
                                            <label for="placeholderInput" class="form-label"> State</label>
                                            <div class="input-group">
                                                <select v-model="state" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Price For Country" disabled>
                                                        <option v-for="(item, index) in listState" :key="index" :value="item.id" >
                                                            {{ item.name }}
                                                        </option>
                                                    </select>
                                            </div>
                                            
                                        </div>
                                        <div class="col-md-4">
                                            
                                            <label for="placeholderInput" class="form-label"> Country</label>
                                            <div class="input-group">
                                                <select v-model="country" class="form-select mb-3" arial-label="Default select example" placeholder="Enter Price For Country" disabled>
                                                        <option v-for="(item, index) in listCOuntry" :key="index" :value="item.id" >
                                                            {{ item.name }}
                                                        </option>
                                                    </select>
                                            </div>
                                            
                                        </div>
                                        
                                            <!-- <label for="placeholderInput" class="form-label" style="font-size: 20px;">Temporary Address</label>

                                            <div class="col-md-8" style="margin-top: 2px;">
                                                <div class="form-check form-check-inline">
                                                <input class="form-check-input" v-model="sameabove" type="checkbox" id="sameabove" @click="duplicateaddress" :disabled="temporaryAddressDisable">
                                                <label class="form-check-label" for="formCheck8"> Temporary address same as permanent address</label>
                                                </div>
                                            </div>
                                            

                                            <div class="col-md-6">
                                                <div>
                                                    <label for="placeholderInput" class="form-label">Address</label>
                                                    <textarea class="form-control" v-model="temporayaddress" rowspan="10" :disabled="temporaryAddressDisable"> </textarea>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                            
                                            <label for="placeholderInput" class="form-label">Zip/Postal</label>
                                            <div class="input-group">
                                                <input type="text" :disabled="temporaryAddressDisable" class="form-control" v-model="postalCodetemp" aria-label="Recipient's username with two button addons">
                                            </div>
                                            
                                        </div>
                                        <div class="col-md-4">
                                            
                                            <label for="placeholderInput" class="form-label"> City</label>
                                            <div class="input-group">
                                                <input type="text" :disabled="temporaryAddressDisable" class="form-control" v-model="citytemp" aria-label="Recipient's username with two button addons">
                                            </div>
                                            
                                        </div>
                                        <div class="col-md-4">
                                            
                                            <label for="placeholderInput" class="form-label"> State</label>
                                            <div class="input-group">
                                                <select :disabled="temporaryAddressDisable" type="text" class="form-select mb-3" placeholder=""  v-model="statetemp" :value="selected" arial-label="Default select example" required>
                                                        <option v-for="(item, index) in listState" :key="index" :value="item.id" >
                                                            {{ item.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                            
                                        </div>
                                        <div class="col-md-4">
                                            
                                            <label for="placeholderInput" class="form-label"> Country</label>
                                            <div class="input-group">
                                                <select :disabled="temporaryAddressDisable"  type="text" class="form-select mb-3" placeholder=""  v-model="countrytemp" :value="selected" arial-label="Default select example" required>
                                                        <option v-for="(item,index) in listCOuntry" :key="index" :value="item.id" @click='getState(item.id)'>
                                                                    {{ item.name }}
                                                        </option>
                                                </select>
                                            </div>
                                            
                                        </div> -->
                                        
                                            
                                            <!--end col-->
                                        </div>
                                        <div v-else>
                                            <div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div>
                                        </div>
                                    </fieldset>

                                    <div class="d-flex align-items-start gap-3 mt-4">
                                        <!-- <button type="button" class="btn btn-success btn-label right ms-auto nexttab nexttab" :disabled='disableUpload' data-nexttab="pills-info-desc-tab" > -->
                                        <button type="button" class="btn btn-success btn-label right ms-auto" :disabled='disableUpload' @click="saveStep1" data-nexttab="pills-info-desc-tab" >
                                            <i class="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>Proceed to References
                                        </button>
                                    </div>  
                                </div>
                                <!-- end tab pane -->

                                <div class="tab-pane fade" id="pills-info-desc" role="tabpanel" aria-labelledby="pills-info-desc-tab">
                                    <!-- <a type="button" class="previestab" data-previous="pills-gen-info-tab" style="color:#77BF4C"><i class="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i> Back</a> -->
                                    <div class="text-right">
                                        <label for="placeholderInput" class="form-label" style="font-size: 20px;">Malaysian National ID (MyKad)</label>
                                        
                                        <div class="row">
                                            <div class="col-md-6">
                                                <h5 class="fs-14">Front Side</h5>
                                                <div class="profile-user position-relative mx-auto mb-2">
                                                    <img src="@/assets/images/users/user-dummy-img2.png" class="avatar-lg img-thumbnail user-profile-image" alt="user-profile-image" style="width: 100%; height:100%">
                                                    <div class="position-absolute top-0 start-0">
                                                        <input id="profile-img-file-input" @change="uploadFilefrontic" ref="frontic" type="file" class="profile-img-file-input" accept="image/png, image/jpeg" >
                                                        <label for="profile-img-file-input" class="">
                                                            <span class="avatar-title bg-light text-body">
                                                                <!-- <i class="ri-file-upload-line"></i> -->
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div v-if='loadingUploadFrontNRIC'>
                                                        <div class="spinner-border text-success" role="status">
                                                            <span class="sr-only">Loading...</span>
                                                        </div>
                                                    </div>
                                                    <div v-if="success_upload_fNric =='success'">                                                   
                                                    <span style="color: green;" >
                                                        {{ success_upload_msg }}
                                                    </span> 
                                                    </div> 
                                                </div>
                                                
                                            </div>
                                        
                                        
                                            <div class="col-md-6">
                                                <h5 class="fs-14">Back Side</h5>
                                                <div class="profile-user position-relative d-inline-block mx-auto mb-2">
                                                    <img src="@/assets/images/users/user-dummy-img3.png" class="avatar-lg img-thumbnail user-profile-imagea w-1000" alt="user-profile-imagea" style="width: 100%; height:100%">
                                                    <div class="position-absolute top-0 start-0">
                                                        <input id="profile-img-file-inputa" @change="uploadFilebacktic" ref="backic" type="file" class="profile-img-file-inputa" accept="image/png, image/jpeg">
                                                        <label for="profile-img-file-inputa" class="">
                                                            <span class="avatar-title bg-light text-body">
                                                                <!-- <i class="ri-file-upload-line"></i> -->
                                                            </span>
                                                        </label>                                                       
                                                    </div>
                                                    <div v-if='loadingUploadBackNRIC'>
                                                        <div class="spinner-border text-success" role="status">
                                                            <span class="sr-only">Loading...</span>
                                                        </div>
                                                    </div>
                                                    <div v-if="success_upload_bNric =='success'">                                                   
                                                            <span style="color: green;" >
                                                                {{ success_upload_bNric_msg }}
                                                            </span> 
                                                    </div> 
                                                </div>
                                                
                                            </div>
                                            
                                        </div>
                                    </div>

                                    <fieldset class="form-group border p-3">
                                        <legend class="w-auto px-2">References Information</legend>
                                        <form>
                                            <div class="row gy-4">
                                        
                                                <div class="col-md-12">
                                                    <div>
                                                        <label for="basiInput" class="form-label">Name<span style="color: red;">*</span></label>
                                                        <input type="text" class="form-control" v-model="ref_name" placeholder="Enter name" v-on:keypress="NameValidation" required>
                                                        <span style="color: red;" v-if="error_ref_name !=''">
                                                            {{ error_ref_name }}
                                                        </span> 
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div>
                                                        <label for="basiInput" class="form-label align-left">Relationship<span style="color: red;">*</span></label>
                                                        <select v-model="relationship" class="form-select mb-3" arial-label="Default select example" required>
                                                            <option value="">Please Select Relationship</option>
                                                            <option v-for="(item,index) in listRelation" :key="index" :value="item.id" >{{ item.name }}</option>
                                                        </select>
                                                        <span style="color: red;" v-if="error_ref_relationship !=''">
                                                            {{ error_ref_relationship }}
                                                        </span> 
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div>
                                                        <label for="basiInput" class="form-label">Mobile Number<span style="color: red;">*</span></label>
                                                        <input type="text" class="form-control" v-model="ref_number" v-on:keypress="NumbersOnly" placeholder="Enter Mobile Number" maxlength="12" minlength="9" required>
                                                        <span style="color: red;" v-if="error_ref_number !=''">
                                                            {{ error_ref_number }}
                                                        </span> 
                                                    </div>
                                                </div>
                                            
                                                <div class="col-md-6" v-if="refListing['0']">
                                                    <button class="btn btn-primary waves-effect waves-light" type="button" @click="refadd"><span>Add Another Reference</span></button>
                                                </div>
                                                <div class="col-md-6" v-else>
                                                    <button class="btn btn-primary waves-effect waves-light" type="button" @click="refadd"><span>Save</span></button>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="alert alert-danger alert-borderless mb-xl-0" v-if="error_refSeen" role="alert">
                                                        {{ error_name_ref }}
                                                    </div>
                                                    
                                                </div>

                                                
                                            </div>
                                        </form>
                                        <br>
                                        <div class="col-md-12 table-responsive-sm" v-if="refListing['0']">
                                                <table class="table align-middle table-nowrap mb-0">
                                                    <thead>
                                                        <th scope="col">No.</th>
                                                        <th scope="col">Name</th>
                                                        <th scope="col">Relationship</th>
                                                        <th scope="col">Mobile Number</th>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item,index) in refListing" :key="index" :value="item.id" >
                                                            <td>{{ index+1}}</td>
                                                            <td>{{ item.name }}</td>
                                                            <td>{{ item.ref }}</td>
                                                            <td>{{ item.contact_number }}</td>
                                                            <td><button class="btn btn-primary" type="button" @click="deleterefadd(item.id)" data-text="Delete"><span>Delete</span></button></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                    </fieldset>
                                    
                                    <div class="d-flex align-items-start gap-3 mt-4 pb-5">
                                        <!-- <button type="button" class="btn btn-link text-decoration-none btn-label previestab" data-previous="pills-gen-info-tab" ><i class="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i> Back to General</button> -->
                                        <button type="button" class="px-4 p-2 previestab" data-previous="pills-gen-info-tab" style="border-color: #77BF4C;background-color: white;color: #77BF4C;border-radius: 5px;"> Back</button>
                                        <button type="button" class="btn btn-success btn-label right ms-auto nexttab nexttab" :disabled="disableTOFinance"  @click="submitFile" >
                                            <i class="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                                            Proceed To Employment Information
                                        </button>
                                    </div>
                                </div>

                                <div class="tab-pane fade" :class="{'hide': emplypg}" id="pills-warning-desc" role="tabpanel" aria-labelledby="pills-info-warning-tab">
                                    <!-- <a type="button" class="previestab" data-previous="pills-info-desc-tab" style="color:#77BF4C"><i class="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i> Back</a> -->
                                    <div class="text-left pb-5">
                                        <fieldset class="form-group border p-3">
                                            <!-- <div class="d-flex align-items-start gap-3 mt-4">
                                                <button type="button" class="btn btn-link text-decoration-none btn-label previestab" data-previous="pills-info-desc" ><i class="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>Back</button>
                                            </div> -->
                                            <legend class="w-auto px-2">Employment Information</legend>
                                            <div class="row gy-4" v-if="(detailSeen && loadingCreditCheck != true)">
                                                <div class="col-md-6">
                                                    <label for="placeholderInput" class="form-label">Company Name<span style="color: red;">*</span></label>
                                                    <input type="text" class="form-control" placeholder="ABC Sdn Bhd" v-model="companyname" required>  
                                                    <span style="color: red;" v-if="error_companyname !=''">
                                                        {{ error_companyname }}
                                                    </span>
                                                    <!-- <input type="text" class="form-control" v-model="renric" v-on:keypress="NumbersOnly" disabled>  -->

                                                </div>
                                                <div class="col-md-6">
                                                    <label for="placeholderInput" class="form-label">Office General Line<span style="color: red;">*</span></label>
                                                    <input type="text" class="form-control" v-model="general_line" placeholder="03 12345678"  v-on:keypress="NumbersOnly" maxlength="10" minlength="9" required>  
                                                    <span style="color: red;" v-if="error_general_line !=''">
                                                        {{ error_general_line }}
                                                    </span>
                                                </div>
                                                <div class="col-md-12">
                                                    <label for="placeholderInput" class="form-label">Do you have any existing credit facilities as below? (you may choose more than 1)<span style="color: red;">*</span></label>
                                                    
                                                        <!-- <div>Loading</div> -->
                                                    
                                                        <div class="form-check form-check-success mb-3">

                                                            <span v-if="loadLoan == false">
                                                                <div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div>
                                                            </span>
                                                            <span v-else>
                                                                
                                                                <div class="mt-4 mt-lg-0">
                                                                    <!-- <div class="form-check form-check-inline" v-for="(item,index) in loanListing" :key="index">
                                                                        <input class="form-check-input" @click="loanLogic" :v-model="item.slug" type="checkbox" :id="item.name" :value="item.name">
                                                                        <label class="form-check-label" :for="item.name"> {{ item.name }} </label>
                                                                        
                                                                    </div> -->

                                                                    <div class="form-check form-check-inline">
                                                                        <input class="form-check-input" v-model="PersonalLoan" type="checkbox" id="PersonalLoan" :disabled="loan_none">
                                                                        <label class="form-check-label" for="formCheck8"> Personal Loan</label>
                                                                    </div>
                                                                    <div class="form-check form-check-inline">
                                                                        <input class="form-check-input" v-model="CreditCard" type="checkbox" id="CreditCard" :disabled="loan_none">
                                                                        <label class="form-check-label" for="formCheck8">Credit Card</label>
                                                                    </div>
                                                                    <div class="form-check form-check-inline">
                                                                        <input class="form-check-input" v-model="CarLoan" type="checkbox" id="CarLoan" :disabled="loan_none">
                                                                        <label class="form-check-label" for="formCheck8"> Car Loan</label>
                                                                    </div>
                                                                    <div class="form-check form-check-inline">
                                                                        <input class="form-check-input" v-model="Housing" type="checkbox" id="Housing" :disabled="loan_none">
                                                                        <label class="form-check-label" for="formCheck8"> Housing Loan</label>
                                                                    </div>
                                                                    <div class="form-check form-check-inline">
                                                                        <input class="form-check-input" v-model="loan_none" type="checkbox" id="none_picker" :disabled="CarLoan || Housing || CreditCard || PersonalLoan">
                                                                        <label class="form-check-label" for="formCheck8"> None</label>
                                                                    </div>
                                                                    
                                                                </div>
                                                                <span style="color: red;" v-if="error_loan !=''">
                                                                    {{ error_loan }}
                                                                </span>
                                                            </span>
                                                            
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-md-6" v-if="salryRange">
                                                                <span v-if="CarLoan || Housing || CreditCard || PersonalLoan">
                                                                    <label v-if="CarLoan || Housing || CreditCard || PersonalLoan" for="placeholderInput" class="form-label">Select your Net Salary Range</label><span style="color: red;">*</span>
                                                                    <select v-if="CarLoan || Housing || CreditCard || PersonalLoan" type="text" class="form-select" placeholder="Select Range" v-model="salary_range" arial-label="Default select example" required>
                                                                        <option value="MYR 0 - MYR 2,500">
                                                                            MYR 0 - MYR 2,500
                                                                        </option>
                                                                        <option value="MYR 2,501 - MYR 3,000">
                                                                            MYR 2,501 - MYR 3,000
                                                                        </option>
                                                                        <option value="MYR 3,001 - MYR 5,000">
                                                                            MYR 3,001 - MYR 5,000
                                                                        </option>
                                                                        <option value="MYR 5,001 - MYR 8,000">
                                                                            MYR 5,001 - MYR 8,000
                                                                        </option>
                                                                        <option value="MYR 8,001 and Above">
                                                                            MYR 8,001 and Above
                                                                        </option>
                                                                    </select>
                                                                    <span style="color: red;" v-if="error_salary_range !=''">
                                                                        {{ error_salary_range }}
                                                                    <br>
                                                                    </span>
                                                                </span>
                                                                
                                                                <span v-if="loan_none">
                                                                    <label for="placeholderInput" class="form-label">Input your Net Salary<span style="color: red;">*</span></label>
                                                                    <input placeholder="5000.00" v-if="loan_none" type="text" class="form-control" v-model="net_salary" required v-on:keypress="NumbersOnly" maxlength="7">
                                                                    
                                                                    <span style="color: red;" v-if="error_net_salary !=''">
                                                                        {{ error_net_salary }}
                                                                    </span>
                                                                </span>
                                                            </div>
                                                            <!-- <div class="col-md-6" v-if="loan_none">
                                                                <label for="placeholderInput" class="form-label">Net Salary *</label>
                                                                <input type="text" class="form-control" v-model="net_salary" required>
                                                            </div> -->
                                                            <div v-if="loan_none" class="col-md-6">
                                                                <label for="placeholderInput" class="form-label">Upload your latest one month Payslip<span style="color: red;">*</span></label>
                                                                <input type="file" ref="uploadPayslip" @change="uploadPayslipF" class="form-control" required>
                                                                <span style="color: red;" v-if="error_uploadPayslip_ !=''">
                                                                        {{ error_uploadPayslip_ }}
                                                                    </span>
                                                            </div>
                                                        </div>
        

                                                        <!-- ModalStart -->
                                                    <div class="container p-5">
                                                        <!-- Button trigger modal -->
                                                        <!-- <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#pdpaModal">
                                                            Open PDF
                                                        </button> -->
                                                        <!-- Modal -->
                                                        <!--TermsConditionsModal @cekFund='cekFund()'></TermsConditionsModal-->
                                                    </div>
                                                    <!-- EndModal -->

                                                    
                                                </div>
                                            
                                            </div>
                                            <div v-else>
                                             <div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div>
                                            </div>
                                        </fieldset>
                                        <div class="d-flex align-items-start gap-3 mt-4 pb-5">
                                            <!-- <button type="button" class="btn btn-link text-decoration-none btn-label previestab" data-previous="pills-gen-info-tab" ><i class="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i> Back to General</button> -->
                                            <!-- <button type="button" class="btn btn-success btn-label right ms-auto nexttab nexttab" data-nexttab="pills-success-tab" :disabled='CreditSubmitCheck' @click='saveData'><i class="ri-arrow-right-line label-icon align-middle fs-16 ms-2" ></i>Submit</button> -->
                                        </div>
                                    </div>
                                    <div class="row">
                                                            <div class="col-md-12">
                                                                <!-- <br>
                                                                <label for="placeholderInput" class="form-label">
                                                                    <input class="form-check-input" v-model="acceptceking"  @click="loanLogic" type="checkbox" id="acceptceking">
                                                                    I accept & acknowledge to <a style="color: #77BF4C;" >PDPA </a>and <a style="color: #77BF4C;" href="#">Terms & Conditions </a>
                                                                </label>
                                                                <br> -->
                                                                <div class="d-flex align-items-start gap-3 mt-4 pb-5">
                                                                    <!-- <a type="button" class="previestab" data-previous="pills-info-desc-tab" style="color:#77BF4C"><i class="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i> Back</a> -->

                                                                    <button type="button" class="px-4 p-2 previestab" data-previous="pills-info-desc-tab" style="border-color: #77BF4C;background-color: white;color: #77BF4C;border-radius: 5px;"> Back</button>
                                                                    <!--button class="btn btn-primary btn btn-success btn-label right ms-auto" type="button"  data-bs-toggle="modal" data-bs-target="#pdpaModal"><span>Proceed To Credit Check</span></button-->
                                                                    <button class="btn btn-primary btn btn-success btn-label right ms-auto" type="button" @click='cekFund()'><span>Confirm</span></button>

                                                                    <!-- <button class="btn btn-primary btn btn-success btn-label right ms-auto nexttab nexttab" type="button"  :disabled='!acceptceking' data-bs-toggle="modal" data-bs-target="#pdpaModal"><span>Proceed To Credit Check</span></button> -->
                                                                </div>
                                                            
                                                            </div>
                                                        </div>
                                </div>
                                <!-- end tab pane -->

                                <div class="tab-pane fade" :class="{'hide': bankpg,'active show': succespg}"  role="tabpanel" aria-labelledby="pills-success-tab">
                                    <div>
                                        <div class="text-right mt-5">
                                            
                                            <!-- <div class="mb-4">
                                                <lottie
                                    colors="primary:#0ab39c,secondary:#405189"
                                    :options="defaultOptions"
                                    :height="120"
                                    :width="120"
                                    />
                                            </div> -->
                                            <h1 class="">{{product_name}}</h1>
                                            <h3 class="pt-2">Highlight</h3>
                                            <h5 class="pt-2">Subscription period</h5>
                                            <p class="text-muted pt-2">{{tenure}} Months</p>
                                            <h3 class="pt-2">Device</h3>
                                            <h5 class="pt-2">Capacity</h5>
                                            <p class="text-muted pt-2">{{capacity_name}}</p>
                                            <h5 class="pt-2">Condition</h5>
                                            <p class="text-muted pt-2">New</p>
                                            <h5 class="pt-2">Color</h5>
                                            <p class="text-muted pt-2">{{color_name}}</p>
                                            <h3 class="pt-2">Delivery</h3>
                                            <h5 class="pt-2">Pickup From Store</h5>
                                            <p class="text-muted pt-2">{{store_name}}</p>
                                            <table class="table align-middle table-nowrap mb-0 pt-2">
                                            
                                                    <tbody class="border-top">
                                                        <th scope="col">Monthly Charge</th>
                                                        <th scope="col"><span style="color: #000000;font-size: 13px;">SGD {{myDecimal(price)}} </span></th>
                                                        
                                                    </tbody>
                                                    <tbody class="border-top">
                                                        <th scope="col">Program Fee</th>
                                                        <th scope="col"><span style="color: #000000;font-size: 13px;">SGD {{myDecimal(program_fee)}} </span></th>
                                                        
                                                    </tbody>
                                                    <tbody class="border-top">
                                                        <th scope="col">Total Upfront Payment</th>
                                                        <th scope="col"><span style="color: #77BF4C;font-size: 20px;">SGD {{ myDecimal(Number(price) + Number(program_fee)) }} </span></th>
                                                        
                                                    </tbody>
                                                </table>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-start gap-3 mt-4 pb-5">
                                        <!-- <button type="button" class="px-4 p-2 previestab" data-previous="pills-info-warning-tab" style="border-color: #77BF4C;background-color: white;color: #77BF4C;border-radius: 5px;" @click="nolaoding"> Back</button> -->

                                        <button @click="(bankpg = true,succespg = false)" type="button" class="btn btn-success btn-label right ms-auto nexttab nexttab" data-nexttab="pills-bank-desc-tab" data-bs-toggle="modal" data-bs-target="#emandateModal">
                                            <i class="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>Confirm Order
                                        </button>
                                    </div>
                                </div>
                                <!-- end tab pane -->

                                <div class="tab-pane fade" :class="{'active show': bankpg}"  id="pills-bank-desc-tab" role="tabpanel" aria-labelledby="pills-bank-desc">
                                    
                                    <div class="text-right mt-5">
                                            
                                            <!-- <div class="mb-4">
                                            <lottie
                                            colors="primary:#0ab39c,secondary:#405189"
                                            :options="defaultOptions"
                                            :height="120"
                                            :width="120"
                                            />
                                            </div> -->
                                            <h5>Your Online Banking Monthly Payment Preference</h5>
                                                <div>
                                                    <div class="col-md-12">
                                                        <div>
                                                            <label for="basiInput" class="form-label">Name as per NRIC<span style="color: red;">*</span></label>
                                                            <input type="text" class="form-control" v-on:keypress="NameValidation" v-model="firstName">
                                                            <span style="color: #b7afaf;">
                                                            e.g. Amir Radzi Bin Muhammad Shamim
                                                            </span> 
                                                        </div>
                                                    </div>
                                                    <label for="placeholderInput" class="form-label">Bank</label>
                                                    <select @change="onChange($event)" v-model="bank" class="form-select mb-3" arial-label="Default select example" required>
                                                        <option value="">Please Select Bank</option>
                                                        <option v-for="(item, index) in listBank" :key="index" :value="item.id">
                                                            {{ item.name.toString().replace(/['"]+/g, '') }}
                                                        </option>
                                                
                                                    </select>
                                                </div>
                                                <div class="d-flex align-items-start gap-3 mt-4">
                                                    <!-- <button @click="$router.push('/customer/create/auth')" class="btn btn-success btn-label right ms-auto nexttab nexttab" data-nexttab="pills-auth-desc-tab" >
                                                        <i class="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>Confirm
                                                    </button> -->
                                                    <button type="button" @click="(bankpg = false,succespg = true)" class="px-4 p-2 previestab" data-previous="pills-success" style="border-color: #77BF4C;background-color: white;color: #77BF4C;border-radius: 5px;"> Back</button>
                                                    <button type="button" class="btn btn-success btn-label right ms-auto nexttab nexttab" @click='tocurlect' data-nexttab="pills-auth-desc-tab" >
                                                        <i class="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>Confirm
                                                    </button>
                                                </div>
                                        
                                        </div>

                                        <EmandateModal></EmandateModal>
                                    
                                
                                </div>

                                    <!-- end tab pane -->

                                <div class="tab-pane fade" :class="{'active show': authpg}" id="pills-auth-desc" role="tabpanel" aria-labelledby="pills-auth-desc-tab">
                                    
                                    
                                
                                </div>
                            </div>
                            </div>
                        </div>
                            

                            <!-- end tab content -->
                        </form>
                
                        
                    </div>
                </div>
                
                <div class="text-center mt-lg-5 pt-5">
                    <div class="d-flex gap-2 justify-content-center mt-4">
                        <!-- <a href="auth-signup-basic.html" class="btn btn-primary">Submit <i class="ri-arrow-right-line align-middle ms-1"></i></a> -->
                    </div>
                </div>
                <!-- end row -->
            </div>
            <!-- end container -->
            <!-- <div class="position-absolute start-0 end-0 bottom-0 hero-shape-svg">
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 1440 120">
                    <g mask="url(&quot;#SvgjsMask1003&quot;)" fill="none">
                        <path d="M 0,118 C 288,98.6 1152,40.4 1440,21L1440 140L0 140z">
                        </path>
                    </g>
                </svg>
            </div> -->
            <!-- end shape -->
            <div id="container">
                        <div id="contacts">
                        <div id="contacts--contact">
                            <div>{{ new Date().getFullYear()  }} &copy; CompAsia</div>
                        </div>
                        <div >
                            <div></div>
                            <div></div>
                            <div>Design & Develop by Compasia IT</div>
                        </div>
                        </div>
                        <div id="mentions">
                        <p></p>
                        </div>
            </div>
        </section>
    </div>
    
</template>